import { FC, useState } from "react";
import "../styles/TextInput.css"
import { camelCase } from "lodash"
import { firestore } from "../firebase";

export interface TextInputProps {
    user: any
}
 
const TextInput: FC<TextInputProps> = ({user}) => {
    const [task, setTask] = useState("")
    
    const handleNewTask = (event: any) => {
        event.preventDefault()
        
        if(user) {
            let savedTasks: any[] = []

            const alreadySaveTasks = JSON.parse(localStorage.getItem("savedTasks") || "[]")

            // Adds the new task
            const newTask = {
                taskName: task,
                taskId: camelCase(task),
                isCompleted: false
            }

            savedTasks.push(newTask)

            if(alreadySaveTasks !== []) {
                for(const e of alreadySaveTasks) savedTasks.push(e)

                for(const e of savedTasks) {
                    const taskId = camelCase(e.taskId)
                    const firestoreRef = firestore.collection(user.uid).doc(taskId)
                    // Adds the new task
                    const newTask = {
                        taskName: task,
                        taskId: taskId,
                        isCompleted: false
                    }
    
                    firestoreRef.set(newTask)
                }
            }
        }   
        else {
            const alreadySaveTasks = JSON.parse(localStorage.getItem("savedTasks") || "[]")
            
            console.table(alreadySaveTasks)

            let savedTasks: any[] = []

            // Adds the new task
            const newTask = {
                taskName: task,
                taskId: camelCase(task),
                isCompleted: false
            }

            if(alreadySaveTasks !== []) {
                for(const e of alreadySaveTasks) savedTasks.push(e)
            }
            
            savedTasks.push(newTask)

            // savedTasks.push(task)
            localStorage.setItem("savedTasks", JSON.stringify(savedTasks))
        }
    }

    return (
        <form className="text-input" onSubmit={handleNewTask}>
            <h2 id="create-task-text">Create a new task</h2>
            <input type="text" placeholder="Enter your new task" id="task-input" value={task} onChange={(e) => setTask(e.target.value)} />
            <button id="create-task-button" >Create Task</button>
        </form>
    );
}
 
export default TextInput;